import { IgButton } from "@intelligems/ig-theme/IgButton";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";
import { handleSwitchToDesktop } from "@src/utils/deviceDetection";

export const SwitchToDesktop = ({ sx = {} }: { sx?: object }) => {
  const experience = useSelector(selectedExperience);
  return (
    <IgButton
      size="large"
      variant="outlined"
      fullWidth
      onClick={() => handleSwitchToDesktop(experience)}
      sx={sx}
    >
      Switch to desktop
    </IgButton>
  );
};
